import React, { useCallback, useEffect, useState } from 'react';
import { api, dataHoraBR, gerarSenha, sessao } from '../api';
import { Campo, Carregando, Modal, useToast } from '../components/Base';

export default function Admins() {
  const [lista, setLista] = useState(null);
  const [acao, setAcao] = useState(null); // { tipo: 'novo' | 'editar', admin? }
  const avisar = useToast();
  const eu = (sessao() || {}).admin || {};

  const carregar = useCallback(() => api('/admins').then(setLista).catch(e => avisar(e.message, 'erro')), [avisar]);
  useEffect(() => { carregar(); }, [carregar]);

  return (
    <>
      <div className="cartao" style={{ marginBottom: 14 }}>
        <div className="linha">
          <div className="mudo pequeno">Quem pode entrar neste painel. Separado dos usuários das empresas.</div>
          <span className="espaco" />
          <button className="btn" onClick={() => setAcao({ tipo: 'novo' })}>+ Novo administrador</button>
        </div>
      </div>
      {!lista ? <Carregando /> : (
        <div className="cartao tabela-wrap mob-cards" style={{ padding: 0 }}>
          <table>
            <thead><tr><th>Nome</th><th>E-mail</th><th>Último login</th><th>Cadastro</th><th></th></tr></thead>
            <tbody>
              {lista.map(a => (
                <tr key={a.id} style={a.ativo === 0 ? { opacity: .55 } : undefined}>
                  <td data-label="Nome">{a.nome}{a.id === eu.id && <span className="mudo pequeno"> (você)</span>}{a.ativo === 0 && <span className="mudo pequeno"> (inativo)</span>}</td>
                  <td data-label="E-mail">{a.email}</td>
                  <td data-label="Último login">{a.ultimo_login ? dataHoraBR(a.ultimo_login) : <span className="mudo">nunca</span>}</td>
                  <td data-label="Cadastro">{dataHoraBR(a.criado_em)}</td>
                  <td style={{ textAlign: 'right' }}><button className="btn secundario pequeno" onClick={() => setAcao({ tipo: 'editar', admin: a })}>Editar</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {acao && <FormAdmin admin={acao.admin} eu={eu} onFechar={() => setAcao(null)} onSalvo={() => { setAcao(null); avisar('Salvo'); carregar(); }} />}
    </>
  );
}

function FormAdmin({ admin, eu, onFechar, onSalvo }) {
  const novo = !admin;
  const [f, setF] = useState({ nome: admin ? admin.nome : '', email: admin ? admin.email : '', senha: novo ? gerarSenha(10) : '', ativo: admin ? admin.ativo !== 0 : true });
  const [salvando, setSalvando] = useState(false);
  const avisar = useToast();
  const set = (k, v) => setF(x => ({ ...x, [k]: v }));
  async function salvar() {
    setSalvando(true);
    try {
      if (novo) await api('/admins', { method: 'POST', body: f });
      else await api('/admins/' + admin.id, { method: 'PUT', body: { nome: f.nome, ativo: f.ativo, senha: f.senha || undefined } });
      onSalvo();
    } catch (e) { avisar(e.message, 'erro'); } finally { setSalvando(false); }
  }
  return (
    <Modal titulo={novo ? 'Novo administrador' : 'Editar administrador'} subtitulo={novo ? '' : admin.email} largura={460} onFechar={onFechar}
      rodape={<><button className="btn secundario" onClick={onFechar}>Voltar</button><button className="btn" onClick={salvar} disabled={salvando}>{novo ? 'Criar' : 'Salvar'}</button></>}>
      <Campo label="Nome *"><input value={f.nome} onChange={e => set('nome', e.target.value)} autoFocus /></Campo>
      {novo && <Campo label="E-mail *"><input type="email" value={f.email} onChange={e => set('email', e.target.value)} /></Campo>}
      <Campo label={novo ? 'Senha * (mínimo 8)' : 'Nova senha (deixe vazio para manter)'}>
        <div className="linha" style={{ flexWrap: 'nowrap' }}>
          <input type="text" value={f.senha} onChange={e => set('senha', e.target.value)} />
          <button type="button" className="btn secundario pequeno" onClick={() => set('senha', gerarSenha(10))}>Gerar</button>
        </div>
      </Campo>
      {!novo && admin.id !== eu.id && <label className="check" style={{ display: 'block' }}><input type="checkbox" checked={f.ativo} onChange={e => set('ativo', e.target.checked)} /> Acesso ativo</label>}
    </Modal>
  );
}
